import accountSettingsModule from '../accountSettingsModule';

function accountsController(
  $scope,
  $state,
  $log,
  notificationConstantsService,
  accountsService,
  commonConstantsService
) {
  'ngInject';

  $scope.accountsTabs = [];

  $scope.currentData = {
    activeTab: '',
    stateLabel: ''
  };

  $scope.initTabs = function() {
    accountsService.beginGetAccountSettingsGroups().then(
      function(tabsListing) {
        for (let i = 0; i < tabsListing.length; i++) {
          $scope.accountsTabs.push({
            name: tabsListing[i].suffix,
            label: tabsListing[i].title
          });
        }
      },
      function(err) {
        $log.debug('Error getting account info.');
      }
    );
  };

  // Check if this user has any configurable notification types
  $scope.mappedDestinationTypes = [];
  $scope.destinationTypes = notificationConstantsService.destinationTypes;

  const getAllowedNotificationDestinationTypes = function() {
    accountsService.beginGetAllowedNotificationDestinationTypes().then(
      function(allowedDestinationTypes) {
        if (allowedDestinationTypes && allowedDestinationTypes.length > 0) {
          $scope.mappedDestinationTypes = $scope.destinationTypes.filter(function(destinationType) {
            return allowedDestinationTypes.indexOf(destinationType) !== -1;
          });
        }
      },
      function(err) {
        $log.debug('Error getting account info');
      }
    );
  };

  accountsService.beginGetAccountInformationMetadata().then(
    function(result) {
      if (!result.isAllowedNotificationsEndpointDisabled) {
        this.getAllowedNotificationDestinationTypes();
      }
    },
    function(err) {
      this.getAllowedNotificationDestinationTypes();
    }
  );

  $scope.accountData = !$scope.accountData
    ? {
        stateProperties: {}
      }
    : $scope.accountData;

  $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
    $scope.currentData.activeTab = toState.name;
    $scope.currentData.stateLabel = commonConstantsService.tabs[toState.name];
  });

  $scope.$watch('accountData', function(newValue, oldValue) {
    $scope.hideMobileTabList = $scope.accountData.stateProperties.hideMobileTabList;
  });

  $scope.initTabs();
}

accountSettingsModule.controller('accountsController', accountsController);

export default accountsController;
